import gql from 'graphql-tag'
import { isPlainObject } from 'lodash'
import toGraphql from '@iez/lib/to-graphql/'

const mutationName = root => `insert_${root}`

const getUpdateColumns = fields =>
  fields
    .filter(field => typeof field === 'string')
    .join(' ')

const fromPatch = patches =>
  Array.isArray(patches) && patches[0]
    ? Object.keys(patches[0]).filter(key => !isPlainObject(patches[0][key])).join(' ')
    : undefined

export default ({ root, fields, patches }) => gql`
  mutation ($objects: [${root}_insert_input!]!) {
    ${mutationName(root)} (
      objects: $objects
    ) {
      returning {
        ${toGraphql(fields)}
      }
    }
  }
`
